import { UIDataModel, UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl } from '../../../../../../ui/toolkit/uicomponent';
import { BaseContext } from '../../../../../../utils/basecontext';
import { UIComponentView } from '../../../../../../ui/toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../../../ui/toolkit/uicomponentcss';
import { MyTonesCardViewImpl } from './mytonescardview';
import { MyTonesCardCSSStyle, MyTonesCardCSSStyleImpl } from './mytonescardcss';
import { ListTonesDto } from '../../../../../../core/dto/listtones/listtonesdto';

export interface MyTonesCardComponentProps extends UIComponentProps
{   
    playingMyTunesdto : ListTonesDto;
    position: number;
    cssStyle:MyTonesCardCSSStyle;

    onDeleteClicked(playingMyTunesdto :ListTonesDto, type:string): void; 
}

export interface MyTonesCardComponentState extends UIComponentState
{
   
}

export interface MyTonesCardComponentHandler extends UIComponentHandler
{
    onDeleteClicked(): void;
}

export class MyTonesCardComponent extends UIComponentImpl<MyTonesCardComponentProps, MyTonesCardComponentState, UIDataModel> implements MyTonesCardComponentHandler
{
    constructor(props: MyTonesCardComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MyTonesCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MyTonesCardCSSStyleImpl(applicationContext);
    }

    // protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    // {
    //      return new ToneCardAPIModelImpl(applicationContext, apiModelHandler);
    // }

    onDeleteClicked(): void 
    {
       this.props.onDeleteClicked(this.props.playingMyTunesdto, this.props.playingMyTunesdto.getType());
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonescardcomponent.tsx